<script setup lang="ts">
import QuizContent from '@/components/quiz/QuizContent.vue';
import QuizNavigation from '@/components/quiz/QuizNavigation.vue';
import useQuizStore from '@/store/quiz';
import { storeToRefs } from 'pinia';
import type { CloseEndedQuestion } from '@ilteducation/exercise-service-types';

const store = useQuizStore();
const { currentQuiz, currentQuestion } = storeToRefs(store);
</script>
<template>
  <div v-if="currentQuiz" class="quiz-container">
    <div v-for="(content, contentIndex) in currentQuiz.content" :key="contentIndex">
      <QuizContent
        v-if="contentIndex === currentQuestion - 1"
        :content-index="contentIndex"
        :content="content as CloseEndedQuestion"
      ></QuizContent>
    </div>
    <QuizNavigation></QuizNavigation>
  </div>
</template>
<style>
.quiz-container {
  width: 100%;
}
</style>
